export default __webpack_public_path__ + "static/media/LowCriticaly.56249706.svg";